function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { isPricingFilter } from 'utils/filterHelpers';
import { routes } from '@shared/routerHistory';
import { Constants } from '@shared/utils/constants';
import { deepEqual } from '@shared/utils/objectUtils';
import { stringifyError } from '@shared/utils/errorUtils';
import { generateGuid, getActiveFeaturedFlags, getTileDataEntityType, getTileDataQueryParams, getProductByUrlKey } from '@shared/utils/appUtils';
import { createTileDataReceivedAction, createTileDataLoadingAction } from '@shared/actions/tileDataActions';
import { getTileData } from '@shared/services/http/entityRestClient';
import { getWindow } from '@shared/services/window';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { createShowingResultsForReceivedAction } from '@shared/actions/actions';
import { createSetRequestFilteredEntityTypeAction, createSetRequestFilteredLoadedAction, createSetRequestFilteredLoadingAction, createSetRequestFilteredQueryAction, createSetResponseFilteredQueryAction } from './queryActions';
import { logger } from '@src/logger';
import { fetchPricingAction } from '@shared/utils/pricingThunkActionUtils';
let prevTileDataRequest;
function generateTileDataLog(requestParams, tileData, duration) {
    var _tileData_apps_dataList_, _getWindow_location, _getWindow;
    const details = {
        duration,
        requestParams,
        searchResponseId: (_tileData_apps_dataList_ = tileData.apps.dataList[0]) === null || _tileData_apps_dataList_ === void 0 ? void 0 : _tileData_apps_dataList_.searchResponseId,
        appsResultsCount: tileData.apps && tileData.apps.count,
        appsTopResults: tileData.apps && tileData.apps.dataList && tileData.apps.dataList.slice(0, 20).map((app)=>app.entityId),
        servicesResultsCount: tileData.services && tileData.services.count,
        servicesTopResults: tileData.services && tileData.services.dataList && tileData.services.dataList.slice(0, 20).map((service)=>service.entityId)
    };
    const payload = {
        page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
        action: Constants.Telemetry.Action.TileData,
        actionModifier: Constants.Telemetry.ActionModifier.End,
        details: JSON.stringify(details)
    };
    SpzaInstrumentService.getProvider().probe(Constants.Telemetry.ProbeName.LogInfo, payload);
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
}
export function loadTileData() {
    return function(dispatch, getState) {
        var _getProductByUrlKey, _prevTileDataRequest_request;
        const start = Date.now();
        const { currentView, billingCountryCode } = getState().config;
        const isBrowseView = currentView === routes.marketplace.name || currentView === routes.marketplaceServices.name || currentView === routes.marketplaceCloudsIndustry.name;
        // Load tile data only in Borwses Apps views, like Home and Gallery
        if (!isBrowseView) {
            return Promise.resolve(null);
        }
        const currentEntityType = getState().config.isAppSource ? getTileDataEntityType(currentView) : Constants.TileDataEntityType.All;
        const currentFilteredQuery = getTileDataQueryParams(getState().config.query);
        const prevEntityType = getState().config.requestFilteredEntityType;
        const prevFilteredQuery = getState().config.requestFilteredQuery;
        if (deepEqual(currentFilteredQuery, prevFilteredQuery) && currentEntityType === prevEntityType) {
            return Promise.resolve(null);
        }
        dispatch(createSetRequestFilteredEntityTypeAction({
            requestFilteredEntityType: currentEntityType
        }));
        dispatch(createSetRequestFilteredQueryAction({
            requestFilteredQuery: currentFilteredQuery
        }));
        dispatch(createSetRequestFilteredLoadingAction());
        if (currentView !== routes.home.name) {
            dispatch(createTileDataLoadingAction({
                urlQuery: currentFilteredQuery
            }));
        }
        const urlQuery = _object_spread({}, currentFilteredQuery, getActiveFeaturedFlags(getState().config.featureFlags));
        const requestParams = {
            requestId: generateGuid(),
            flightCodes: getState().config.flightCodes,
            embedHost: (_getProductByUrlKey = getProductByUrlKey({
                urlKey: getState().config.embedHost
            })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey,
            billingRegion: isPricingFilter(currentFilteredQuery) ? getState().config.billingCountryCode : '',
            urlQuery,
            entityType: currentEntityType,
            isConverged: getState().config.isConverged
        };
        prevTileDataRequest === null || prevTileDataRequest === void 0 ? void 0 : (_prevTileDataRequest_request = prevTileDataRequest.request()) === null || _prevTileDataRequest_request === void 0 ? void 0 : _prevTileDataRequest_request.abort();
        prevTileDataRequest = getTileData(requestParams);
        return prevTileDataRequest.data$.then((tileData)=>{
            prevTileDataRequest = null;
            generateTileDataLog(_object_spread_props(_object_spread({}, requestParams), {
                origin: tileData.origin,
                suggestionsRequestId: getState().search.suggestionsRequestId
            }), tileData, Date.now() - start);
            dispatch(createSetRequestFilteredLoadedAction());
            dispatch(createSetResponseFilteredQueryAction({
                responseFilteredQuery: currentFilteredQuery
            }));
            dispatch(createTileDataReceivedAction({
                entityType: Constants.EntityType.App,
                entityData: tileData.apps,
                urlQuery: currentFilteredQuery,
                requestId: requestParams.requestId
            }));
            dispatch(createTileDataReceivedAction({
                entityType: Constants.EntityType.Service,
                entityData: tileData.services,
                urlQuery: currentFilteredQuery,
                requestId: requestParams.requestId
            }));
            dispatch(createTileDataReceivedAction({
                entityType: Constants.EntityType.CloudsIndustry,
                entityData: tileData.cloudsIndustry,
                urlQuery: currentFilteredQuery,
                requestId: requestParams.requestId
            }));
            dispatch(fetchPricingAction({
                countryCode: billingCountryCode,
                apps: tileData.apps.dataList.concat(tileData.cloudsIndustry.dataList)
            }));
            dispatch(createShowingResultsForReceivedAction({
                showingResultsFor: tileData.showingResultsFor,
                previousSearchText: currentFilteredQuery.search
            }));
            return tileData;
        }).catch((err)=>{
            var _getWindow_location, _getWindow;
            prevTileDataRequest = null;
            const payload = {
                page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
                action: Constants.Telemetry.Action.TileData,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                details: JSON.stringify({
                    duration: Date.now() - start,
                    requestParams,
                    error: stringifyError(err)
                })
            };
            SpzaInstrumentService.getProvider().probe(Constants.Telemetry.ProbeName.LogInfo, payload);
            logger.error(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            throw err;
        });
    };
}
